export const users = {
  title: 'Accounts',
  name: 'Account',
  resourceName: 'Accounts',
  titles: {
    view: 'View account',
    show: 'Show account',
    edit: 'Edit account',
    create: 'Create account',
    list: 'List accounts',
    addQuick: 'Add quick',
  },
  tabs: {
    profile: 'My profile',
    password: 'Change password',
    settings: 'Settings',
  },
  fields: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phoneNumber: 'Phone number',
    address: 'Address',
    gender: 'Gender',
    birthday: 'Birthday',
    department: 'Department',
    position: 'Position',
    dateJoined: 'Date Joined',
    username: 'Username',
    avatar: 'Avatar',
    avatarZoom: 'Zoom',
    avatarRotate: 'Rotate',
    language: 'Language',
    theme: 'Theme',
    timezone: 'Timezone',
    dateFormat: 'Date Format',
    'notifications.email': 'Email notifications',
    'notifications.sms': 'SMS notifications',
    'notifications.inApp': 'In-app notifications',
    id: 'ID',
    role: 'Role',
    status: 'Status',
    warehouse: 'Warehouse',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
    oldPassword: 'Old password',
    newPassword: 'New password',
    newPasswordRetype: 'Confirm new password',
  },
  actions: {
    saveProfile: 'Save Profile',
    saveSettings: 'Save Settings',
    changePassword: 'Change Password',
    changeAvatar: 'Change Avatar',
    cropAvatar: 'Edit avatar',
    applyCrop: 'Use this photo',
    rotate90: 'Rotate 90°',
    exportList: 'Export list',
    syncFromAuth: 'Pull from Auth',
    columnPicker: 'Choose visible columns',
  },
  messages: {
    noData: 'No data',
    loadUserError: 'Unable to load user details',
    totalUsers: 'Total: {total} users',
    savedSuccess: 'Saved successfully',
    saving: 'Saving...',
    updateSuccess: 'User updated successfully',
    createSuccess: 'User created successfully',
    errorGeneric: 'An error occurred',
    loading: 'Loading...',
    profileUpdateSuccess: 'Profile updated successfully',
    profileUpdateError: 'Failed to update profile',
    passwordUpdateSuccess: 'Password updated successfully',
    passwordUpdateError: 'Failed to update password',
    settingsUpdateSuccess: 'Settings updated successfully',
    settingsUpdateError: 'Failed to update settings',
    avatarUpdateSuccess: 'Avatar updated successfully',
    avatarUpdateError: 'Failed to update avatar',
    passwordLength: 'Password must be at least 8 characters',
    passwordMatch: 'Password confirmation does not match',
    changePasswordError: 'Failed to change password',
    oldPasswordIncorrect: 'Old password is incorrect',
    userNotFound: 'User not found or inactive',
    exportSuccess: 'User list exported successfully',
    exportFailed: 'Failed to export user list',
    syncFromAuthRunning: 'Pulling users from Auth…',
    syncFromAuthSuccess:
      'Pulled {tongUser} users ({taoMoi} new, {capNhat} updated), {soPhanQuyen} assignments.',
    syncFromAuthFailed: 'Failed to pull users from Auth',
  },
  search: {
    title: 'Username',
    placeholder: 'Username',
  },
  filter: {
    placeholder: 'Search by username, full name...',
    advancedFilter: 'Advanced filter',
    username: 'Username',
    fullName: 'Full name',
    role: 'Role',
    chucNang: 'Function',
    chucNangOptions: {
      nhanVienKinhDoanh: 'Sales staff',
      nhanVienKyThuat: 'Technician',
    },
    duAn: 'Project',
    chiNhanh: 'Branch',
    clearFilter: 'Clear filter',
    search: 'Search',
    all: 'All',
  },
  validation: {
    usernameRequired: 'Please enter username',
    passwordRequired: 'Please enter password',
    usernameFormat: 'Username must be 3–50 characters: letters, digits and . _ - only (no spaces)',
    passwordLength: 'Password must be at least 8 characters',
    passwordStrength: 'Password must contain both letters and digits',
    emailInvalid: 'Invalid email',
    phoneInvalid: 'Invalid phone number',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  roles: {
    super_admin: 'Super admin',
    admin: 'Admin',
    manager: 'Manager',
    standard_user: 'Staff',
    customer: 'Customer',
  },
  detailTabs: {
    overview: 'Overview',
    info: 'Details',
    phamViXemDon: 'Order visibility',
    customersInCharge: 'Customers in charge',
    orders: 'Orders',
  },
  detail: {
    basicInfo: 'Basic information',
    personalInfo: 'Personal information',
    unit: 'Unit',
  },
  form: {
    loginInfo: 'Login information',
    personalInfo: 'Personal information',
    passwordLabel: 'Password',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password (min 8 characters)',
    fullNamePlaceholder: 'Enter full name',
    emailPlaceholder: 'Enter email',
    phonePlaceholder: 'Enter phone number',
    isActiveLabel: 'Active',
  },
  phamViXemDon: {
    title: 'Order visibility',
    description:
      'By default each staff member can see all orders in the project. Narrow only with “Mine only” or “Selected staff”.',
    loadError: 'Failed to load order visibility.',
    loadOptsError: 'Failed to load staff / customers.',
    savedSuccess: 'Order visibility saved.',
    saveError: 'Failed to save order visibility.',
    pickUsers: 'Select staff…',
    pickCustomers: 'Select customers…',
    selectedCount: '{count} selected',
    saveNguoiBan: 'Save',
    saveKhachHang: 'Save',
    nguoiBan: {
      title: 'By salesperson',
      hint: 'Who may view orders/invoices by salesperson.',
      targets: 'May view orders of',
      cheDo: {
        toanDuAn: 'See all orders in the project',
        toanDuAnShort: 'All',
        toanDuAnHint: 'New staff are included automatically — no re-selection.',
        chiMinh: 'Mine only',
        chiMinhShort: 'Mine',
        chiMinhHint: 'Only own sales and customers they own.',
        whitelist: 'Select staff whose orders may be viewed',
        whitelistShort: 'Pick staff',
      },
    },
    khachHang: {
      title: 'By customer',
      hint: 'Customers whose invoices this user may open — unselected stay hidden.',
      customers: 'Customers allowed',
    },
  },
  profile: {
    title: 'Personal Information',
    subtitle: 'Update your personal information',
    personalInfo: 'Personal Information',
    workInfo: 'Work Information',
  },
  changePassword: {
    title: 'Change Password',
    subtitle: 'Update your password to protect your account',
    note: 'After a successful change, you will be signed out. Sign in again with the new password.',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Update your settings',
  },
  departments: {
    HE_THONG: 'System',
    SALES: 'Sales',
    CUSTOMER_SERVICE: 'Customer Service',
    DOCUMENTATION: 'Documentation',
    WAREHOUSE: 'Warehouse',
    ACCOUNTING: 'Accounting',
    MANAGEMENT: 'Management',
  },
  positions: {
    SYSTEM: 'System',
    HO: 'HO',
    DIRECTOR: 'Director',
    MANAGER: 'Manager',
    STAFF: 'Staff',
    INTERN: 'Intern',
  },
}
